import React from 'react'
import PropTypes from 'prop-types'
import { MyTimesheetButton } from './my-timesheet-button'
import TimesheetByProjectButton from './timesheet-by-projects-button'
import TimesheetStatusButton from './timesheet-status-button'
import { TimesheetApprovalButton } from './timesheet-approval-button'

export const ButtonGroup = (props) => {
  switch (props.activeTab) {
    case 1:
      return <MyTimesheetButton { ...props } />
    case 2:
      return <TimesheetByProjectButton { ...props } />
    case 3:
      return <TimesheetStatusButton { ...props } />
    case 4:
      return <TimesheetApprovalButton { ...props } />
    default:
      return null
  }
}

ButtonGroup.propTypes = {
  activeTab: PropTypes.number.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/timesheet/tab/button-group/index.js